import { Group, Paper, Text, Tooltip, UnstyledButton } from '@mantine/core';

interface CardProps {
  icon?: React.ReactNode;
  label: string;
  desc: string;
  active: boolean;
  onClick?: () => void;
}

export const Card = ({ active, desc, icon, label, onClick }: CardProps) => {
  return (
    <UnstyledButton onClick={onClick} style={{ width: '200px' }}>
      <Tooltip label={desc}>
        <Paper
          p="md"
          withBorder
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            borderRadius: '8px',
            transition: 'all 0.3s ease',
            border: active ? '1px solid #7C68FB' : '1px solid #e9ecef',
          }}
        >
          <Group justify="space-between" align="center">
            <Group gap="xs">
              {icon && icon}
              <Text size="sm" truncate="end" className="max-w-[150px] whitespace-nowrap">
                {label}
              </Text>
            </Group>
          </Group>
          <Text size="xs" className="pt-1" truncate="end">
            {desc}
          </Text>
        </Paper>
      </Tooltip>
    </UnstyledButton>
  );
};
